import TSXComponent from '@/utils/tsx-component';
import PageView from '@/components/page-view';
import Component from 'vue-class-component';
import PreEnrol from './PreEnrol';
import { Button } from '@ohu-mobile/core';
import './index.scss';

@Component({ name: 'pre-enrol-view' })
export default class PreEnrolView extends TSXComponent {
  public render() {
    return (
      <PageView
        title="高职提前招生查询"
        navBarProps={{ segmentation: [ 2, 5, 2 ] }}
        shareParams={{
          moduleCode: '高职提前招生',
          areaCode: '浙江',
          showAreaCode: 'C99',
        }}>
        <Button
          type="primary"
          link
          inline
          slot="navbar-right"
          to="article?moduleCode=高职提前招生&showAreaCode=C20&title=高职提前招生使用帮助&merge=1">
          使用帮助
        </Button>
        <PreEnrol />
      </PageView>
    );
  }
}
